import {AlertIcon} from '@primer/octicons-react'
import styles from './PendingPromptNotice.module.css'

/**
 * Renders a notice at the end of session logs when a non-steerable session
 * has a pending interaction prompt (permission, user question, plan approval, etc).
 */
export function PendingPromptNotice() {
  return (
    <div className={styles.container} data-testid="pending-prompt-notice" role="status">
      <AlertIcon size={16} className={styles.icon} />
      <span className={styles.text}>Respond to the agent prompt in your local CLI session to continue.</span>
    </div>
  )
}
